module.exports = __webpack_public_path__ + "static/img/fmph-logo.feb3232.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fmph-logo.png
// module id = c6vm
// module chunks = 0